module.exports = ".footer{\r\n    background: #212121;\r\n    color:#fff;\r\n    text-align: center;\r\n    padding:10px;\r\n    position: absolute;\r\n    bottom: -40px;\r\n    right:0;\r\n    left:0;\r\n    \r\n}\r\n\r\n@media print{\r\n    #footer{\r\n        display:none;\r\n    }\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/footer/footer.component.css
// module id = ./src/app/common/footer/footer.component.css
// module chunks = main